// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".g-goto-login{display:flex;font-family:PingFang SC;justify-content:center;align-content:center;font-style:normal;font-weight:500;font-size:14px;margin-top:20px}.g-goto-login>span{line-height:24px;text-align:center;color:#b4b8bf}.g-goto-login>button{line-height:22px;text-align:center;color:#2254f4}.g-goto-login__login-icon{color:#2254f4}.g-goto-login:hover .g-goto-login__login-btn{font-weight:700;color:#2254f4}", ""]);
// Exports
module.exports = exports;
